import React, { useEffect, useMemo, useRef, useState } from "react"
import { useAsync, useQuery } from "../../utils";
import { Header } from "../shared";
import { useHistory } from 'react-router'
import { ProductDetail, ProductPrice } from "../Admin";
import { ProductModel, IDongGoi } from "../../models";
import { searchEsProduct } from "../../api";


const ProductDetailDashboard = () => {
    const query = useQuery();
    const productId: string = query.get("productId") || "";
    const tab = query.get('tab')
    const _packageId = query.get('packageId') || ''

    const history = useHistory()
    const [packageId, setPackageId] = useState(_packageId)

    const searchProductAsync = useAsync(searchEsProduct);


    useEffect(() => {
        searchProductAsync.execute(getQuery(productId));
    }, [productId]);

    const getQuery = (productId: string) => {
        return {
            query: {
                match: {
                    _id: productId,
                },
            },
        };
    };

    const product: any = useMemo(() => {
        const _product: ProductModel = searchProductAsync.value?.data[0];
        if (!packageId) {
            _product?.dong_goi?.map((dong_goi: any) => {
                if (dong_goi.mac_dinh) {
                    setPackageId(dong_goi?.id)
                }
            })
        }

        return {
            ..._product,
        };
    }, [searchProductAsync.value]);



    return <div className="admin-dashboard">
        <Header
            title="Sản phẩm"
            subTitle={"ID: " + productId}
        />
        <div id="admin-menu" className="distributor-menu">
            <div className="container">
                <div className="menu-tabs">
                    <a onClick={() => history.replace(`/product-detail-dashboard?tab=detail&productId=${productId}`)} className={`${tab === "detail" && "active"}`} >Thông tin sản phẩm</a>
                    <a onClick={() => history.replace(`/product-detail-dashboard?tab=price&productId=${productId}&packageId=${packageId}`)} className={`${tab === "price" && "active"}`}> <span>Giá sản phẩm</span></a>
                </div>
            </div>
        </div>
        {tab === "detail" && <ProductDetail
            product={product}
        />}
        {tab === "price" && <ProductPrice
            product={product}
        />}
    </div>
}

export default ProductDetailDashboard;